// extracted by mini-css-extract-plugin
export default {"badge":"TableAds_badge__I48kY","container":"TableAds_container__fv4z1"};